export const SET_HOME_TITLES = 'SET_HOME_TITLES'

const initialState = {
  foldLinks: [],
  categories: [],
  loading: true,
  appSettingId: null,
  systemMessage: null,
  messageAppSettingId: '',
  rawStructure: {
    foldLinks: [],
    categories: [],
  },
  bannerTitle: '',
  bannerSubtitle: '',
  bannerButtonUrl: '',
  bannerButtonText: '',
  mainTitle: '',
  mainSubcontent: '',
}

const HomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@h/RESET_STATE':
      return initialState
    case '@@h/SET_HOME_STRUCTURE':
      const newState = {
        ...state,
        foldLinks: action.foldLinks,
        categories: action.categories,
        appSettingId: action.appSettingId,
      }
      if (action.rawStructure) {
        newState.rawStructure = action.rawStructure
      }
      return newState
    case '@@h/UPDATE_CATEGORIES':
      return { ...state, categories: action.categories }
    case '@@h/POPULATE_SYSTEM_MESSAGE':
      return {
        ...state,
        systemMessage: action.systemMessage,
        messageAppSettingId: action.messageAppSettingId,
      }
    case '@@h/UPDATE_SYSTEM_MESSAGE':
      return { ...state, systemMessage: action.message }
    case '@@h/UPDATE_FOLD_LINKS':
      return { ...state, foldLinks: action.foldLinks }
    case SET_HOME_TITLES:
      return {
        ...state,
        bannerTitle: action.bannerTitle,
        bannerSubtitle: action.bannerSubtitle,
        bannerButtonUrl: action.bannerButtonUrl,
        bannerButtonText: action.bannerButtonText,
        mainTitle: action.mainTitle,
        mainSubcontent: action.mainSubcontent,
      }
    default:
      return state
  }
}
export default HomeReducer
